import React, { memo } from 'react'
import { Grid } from '@mui/material'

import Text from '../shared/text/Text'
import HeadingText from '../shared/text/HeadingText'

const DisplayStats = ({
  data,
  reverseTitle,
  isDescLarge,
  gridSize = 6,
  sx
}) => {
  return (
    <Grid container spacing={2} sx={sx}>
      {data.map(({ label, value, helpText, isPrimary }, index) => {
        const title = (
          <Text
            variant='h4'
            label={label}
            fontWeight={700}
            sx={{ fontSize: isDescLarge ? 22 : 18 }}
          />
        )
        const description = (
          <HeadingText
            label={value}
            isLargeFont={isDescLarge}
            helpText={helpText}
            color={isPrimary && 'primary.main'}
          />
        )
        return (
          <Grid item key={index} xs={12} sm={gridSize}>
            {reverseTitle ? description : title}
            {reverseTitle ? title : description}
          </Grid>
        )
      })}
    </Grid>
  )
}

export default memo(DisplayStats)
